import {autoserialize} from 'cerialize';

export class BijbError extends Error {
  @autoserialize
  public fatal = false;

  @autoserialize
  public error: string;

  @autoserialize
  public message: string;

  @autoserialize
  public name: string;

  @autoserialize
  public status: number;

  @autoserialize
  public statusText: string;

  @autoserialize
  public url: string;
}
